module.exports = __webpack_public_path__ + "static/media/yt-shipping-protection.791f1aa9.jpeg";